import { combineReducers } from 'redux'
import battlefeedReducer from './battlefeed/reducer'

export default (history) => combineReducers({
    battlefeed: battlefeedReducer,
});